export default (str: string | number, decimalPlaces = 2) => {
  return !isNaN(Number(str))
    ? `£${(Math.round(Number(str)) / 100).toFixed(decimalPlaces)}`
    : str
}
